import { motion } from 'framer-motion';

// PLACEHOLDER: Record a 60–90 second video of Uzair and/or Fahad explaining:
//   1. What problem they watched physicians face
//   2. Why they left to build Aura-Chart
//   3. What they want for their founding clinic cohort
//
// To activate: upload to /public/founder-video.mp4 and replace the placeholder div
// below with:
//   <video src="/founder-video.mp4" controls poster="/founder-video-poster.jpg"
//          className="w-full" />
// Or embed a Loom/YouTube link using an <iframe>.

export default function FounderVideo() {
  return (
    <section className="py-20 md:py-28 bg-white border-t border-gray-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="section-label">From the founders</p>
          <h2 className="mt-3 section-heading">Why we built Aura-Chart</h2>
          <p className="mt-4 section-sub">
            Hear directly from Uzair and Fahad on the documentation burden they watched
            physicians carry — and why they left to solve it.
          </p>

          <div className="mt-10 rounded-2xl border border-gray-200 bg-gray-50 aspect-video flex flex-col items-center justify-center gap-4">
            <div className="h-16 w-16 rounded-full bg-primary-50 flex items-center justify-center">
              <svg
                className="h-8 w-8 text-primary-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                />
              </svg>
            </div>
            <p className="text-sm font-medium text-gray-400">Video coming soon</p>
          </div>

          <div className="mt-8">
            <a
              href="https://calendly.com/pulsestack1/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors"
            >
              Prefer to talk? Book a 30-minute call →
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
